import * as React from 'react'

import LiteratureGradeLevel, { GRADE_CONFIGS } from '../../../containers/literature/LiteratureGradeLevel'
import AssignmentFlowNavigation from '../assignment_flow_navigation'
import { getPageTitle } from '../../../../Shared'

const AssignLiteratureGradeLevel = ({ match, ...props }) => {
  const grade = match.params.grade
  const config = GRADE_CONFIGS[grade]
  document.title = getPageTitle("Assign", `Literature | ${config.gradeName}`)

  return (
    <div>
      <AssignmentFlowNavigation courseSlug={grade} />
      <LiteratureGradeLevel gradeLevel={grade} {...props} />
    </div>
  )
}

export default AssignLiteratureGradeLevel
